import { StyleSheet, Text, View } from 'react-native';
import { useState } from 'react';
import Svg, { Circle, G } from 'react-native-svg';
import Colors from '../../constants/Colors';
import TabButton from '../TabButton';
import DateLabel from './DateLabel';
import Style from '../../constants/Style';

interface PieChartWidgetProps {
  range: any;
  compareRange: any;
  locationName: string;
}

const PieChartWidget = (props: PieChartWidgetProps) => {
  const samplePercentage: number = 75;
  const { locationName } = props;

  const [graphSelected, setGraphSelected] = useState<boolean>(true);
  const [containerWidth, setContainerWidth] = useState<number>(0);
  const height: number = (containerWidth - 72) / 4;
  const pieWidth: number = height - 100;
  const radius: number = pieWidth / 2;
  const strokeDasharray: number = Math.PI * pieWidth;
  const percentage: number = samplePercentage;
  const dataValid: boolean = percentage >= 0;
  const strokeWidth: number = 12;

  return (<View
    style={[styles.container, { height }]}
    onLayout={({ nativeEvent: { layout: { width } } }) => setContainerWidth(width)}
  >
    <View style={{ flexDirection: 'row' }}>
      <View style={{ flex: 1 }}>
        <Text style={styles.locationName}>{locationName}</Text>
        <DateLabel />
      </View>
      <View style={{ flexDirection: 'row', alignItems: 'flex-start' }}>
        <TabButton
          title='GRAPH'
          select={() => setGraphSelected(true)}
          selected={graphSelected}
        />
        <TabButton
          title='INSIGHTS'
          select={() => setGraphSelected(false)}
          selected={!graphSelected}
        />
      </View>
    </View>
    {graphSelected
      ? <View style={{ flex: 1, justifyContent: 'center', flexDirection: 'row' }}>
        <View
          style={{ justifyContent: 'center', maxHeight: 500 }}>
          <Svg style={{ width: pieWidth + strokeWidth, height: pieWidth + strokeWidth }}>
            <G
              translate={[radius + strokeWidth / 2, radius + strokeWidth / 2]}
            >
              {dataValid ? <>
                <Circle
                  r={radius}
                  fill='transparent'
                  {...{ strokeWidth, strokeDasharray }}
                  stroke={Colors.light.hereworksYellow500}
                  strokeDashoffset={(1 - (percentage / 100)) * strokeDasharray}
                />
                <Circle
                  rotation={(360 * percentage) / 100}
                  r={radius}
                  fill='transparent'
                  {...{ strokeWidth, strokeDasharray }}
                  stroke={Colors.light.hereworksRed500}
                  strokeDashoffset={(percentage / 100) * strokeDasharray}
                />
              </> : <Circle
                r={radius}
                fill='transparent'
                {...{ strokeWidth, strokeDasharray }}
                stroke={Colors.light.hereworksPrimaryGrey600}
                strokeDashoffset={0}
              />}
            </G>
          </Svg>
          <View style={{ position: 'absolute', alignSelf: 'center', alignItems: 'center' }}>
            <Text style={styles.totalHours}>160</Text>
            <Text style={styles.hoursLabel}>Hours</Text>
          </View>
        </View>
        <View style={{ justifyContent: 'center', marginLeft: 32 }}>
          <View style={Style.row}>
            <View style={[styles.square, { backgroundColor: Colors.light.hereworksRed500 }]} />
            <Text style={styles.legendText}>Unoccupied time</Text>
            <Text style={styles.legendHours}>32h</Text>
            <Text style={styles.legendPercent}>(20%)</Text>
          </View>
          <View style={{ flexDirection: 'row', marginTop: 4, alignItems: 'center' }}>
            <View style={[styles.square, { backgroundColor: Colors.light.hereworksYellow500 }]} />
            <Text style={styles.legendText}>Occupied time</Text>
            <Text style={styles.legendHours}>132h</Text>
            <Text style={styles.legendPercent}>(80%)</Text>
          </View>
        </View>
      </View> : <View style={styles.infoTab}>
        <Text>No Information Available</Text></View>}
  </View>);
};

export default PieChartWidget;

const styles = StyleSheet.create({
  container: {
    padding: 16,
    justifyContent: 'center',
  },
  locationName: {
    fontFamily: 'Poppins_400Regular',
    fontSize: 18,
    lineHeight: 27,
    color: Colors.light.hereworksBlack600,
    marginBottom: 4,
  },
  infoTab: {
    minHeight: 200,
    justifyContent: 'center',
    alignSelf: 'center',
    flex: 1,
  },
  square: {
    width: 16,
    height: 16,
    borderRadius: 2,
    marginRight: 8,
  },
  legendText: {
    marginRight: 24,
    fontFamily: 'Roboto_400Regular',
    fontSize: 14,
    lineHeight: 22,
    color: Colors.light.hereworksBlack600,
  },
  legendHours: {
    fontFamily: 'Roboto_500Medium',
    fontSize: 12,
    lineHeight: 20,
    color: Colors.light.hereworksBlack600,
  },
  legendPercent: {
    fontFamily: 'Roboto_500Medium',
    fontSize: 12,
    lineHeight: 20,
    color: Colors.light.hereworksBlack400,
    marginLeft: 4,
  },
  totalHours: {
    fontFamily: 'Poppins_600SemiBold',
    fontSize: 30,
    lineHeight: 30,
    color: Colors.light.hereworksBlack600,
    marginBottom: 2,
  },
  hoursLabel: {
    fontFamily: 'Roboto_400Regular',
    fontSize: 16,
    lineHeight: 22,
    color: Colors.light.hereworksBlack400,
  },
});
